import { gql } from '@apollo/client';

const RESET_PASSWORD = gql`
  mutation resetPassword($token: String!, $password: String!) {
    resetPassword(token: $token, password: $password)
  }
`;

export default RESET_PASSWORD;
